export const NAME = 'Sitemap';



// WEBPACK FOOTER //
// ./modules/Sitemap/redux/constants.js